import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import OtpAuthForm from './OtpAuthForm';

const AuthModal = ({ isOpen, onClose }) => {
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'unset';
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        // Prevent closing if login is in progress
        if (isProcessing) return;
        if (e.target.classList.contains('auth-modal-overlay')) onClose();
    };

    return (
        <div className="auth-modal-overlay" onClick={handleBackdropClick} style={{ cursor: isProcessing ? 'not-allowed' : 'auto' }}>
            <div className="auth-bg-blue" />
            <div className="auth-modal-content" onClick={(e) => e.stopPropagation()} style={{ cursor: 'auto' }}>
                {!isProcessing && (
                    <button className="close-modal-btn" onClick={onClose} aria-label="Close">
                        <X size={18} />
                    </button>
                )}

                {/* Brand header */}
                <div className="auth-brand">
                    <span className="auth-brand-name">Hotel<strong>Air</strong></span>
                </div>

                <OtpAuthForm
                    onSuccess={onClose}
                    onLoading={(loading) => setIsProcessing(loading)}
                />
            </div>
        </div>
    );
};

export default AuthModal;
